import React from 'react';
import PropTypes from 'prop-types';

const TaskTitle = ({ isEditing, isCompleted, handleTitleEdits, children }) => {
  if (isEditing) {
    return (
      <input
        className='task-title'
        type='text'
        value={children}
        onChange={handleTitleEdits}
      />
    );
  }
  if (isCompleted) {
    return (
      <span style={{ textDecoration: 'line-through' }} className='task-title'>
        {children}
      </span>
    );
  }

  return <span className='task-title'>{children}</span>;
};

TaskTitle.propTypes = {
  isEditing: PropTypes.bool.isRequired,
  isCompleted: PropTypes.bool.isRequired,
  handleTitleEdits: PropTypes.func.isRequired
};

export default TaskTitle;
